// @flow
if (process.env.NODE_ENV === 'development') {
  const utagLogger = (methodName) => (data) => {
    console.groupCollapsed(`utag.${methodName}`); // eslint-disable-line no-console
    console.log(data); // eslint-disable-line no-console
    console.groupEnd(); // eslint-disable-line no-console
  };

  window.utag = {
    link: utagLogger('link'),
    view: utagLogger('view'),
  };
}

export function sendEvent(category: string, action: string, label: string, eventName: string) {
  const linkData = {
    ga_eventCategory: category,
    ga_eventAction: action,
    ga_eventLabel: label,
    event_name: eventName,
  };

  if (!window.utag) return;

  try {
    window.utag.link(linkData);
  } catch (e) {
    console.log('Error sending event to Tealium', e);
  }
}

export function getEnvironment() {
  if (!window.location.host) return;

  const regex = /^.*(?=(\.healthcare)|(\.cuidadodesalud))/g;
  const envArray: ?Array<string> = window.location.host.match(regex);
  if (!envArray) return;

  return envArray[0] === 'www' ? 'production' : envArray[0];
}
